import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NavigateService } from 'src/app/core/services/navigate.service';
import { ProductDownloadService } from 'src/app/core/services/product-download.service';
import { ProductDto } from 'src/app/model/ProductDto';
import { ProductRelease } from 'src/app/model/ProductRelease';
import { TranslatedVariables } from 'src/app/commons/translated-variables';
import { ST_Roles, StoreRolesService } from 'src/app/core/services/store-role.service';
import { ProductCode } from 'src/app/model/industry';
import { CustomerService } from 'src/app/core/services/customer.service';
import { OperationResult } from '@tb/auth';
import { AdministrativeInfoContainer } from 'src/app/model/AdministrativeInfo';
import { Subscription } from 'rxjs';

@Component({
  selector: 'ms-family-products',
  templateUrl: './family-products.component.html',
  styleUrls: ['./family-products.component.scss']
})
export class FamilyProductsComponent implements OnInit {
  isLoading: boolean = false;
  isPlatinumPartner: boolean = true;
  productDto: ProductDto;
  internetRole: string;
  public administrativeInfo: Subscription;

  familyProducts: ProductRelease[] = [];
  familyProductsOriginal: ProductRelease[] = [];

  search = this._formBuilder.group({
    searchString: '',
  });

  filterStrings: string[] = ['all', 'executable', 'development'];
  orderStrings: string[] = ['weight', 'date', 'alphabetic'];
  activeFilter: string = 'all';
  activeOrder: string = 'weight';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private productDownloadService: ProductDownloadService,
    private _formBuilder: FormBuilder,
    private navigateService: NavigateService,
    private variable: TranslatedVariables,
    public storeRolesService: StoreRolesService,
    public customerService: CustomerService
  )
  { }


  getFilters():string[] {
    return this.isPlatinumPartner ? ['all', 'executable', 'development'] : [];
  }

  async ngOnInit() {
    if(!this.navigateService.getLocalStorageData<ProductDto>('productDto'))
      this.router.navigate(['/products-download/products-download'])
    this.productDto = this.navigateService.getLocalStorageData<ProductDto>('productDto');

    try {
      this.isLoading = true
      
      this.productDownloadService.setPlatinumPartner(this.getProductCodeZucchetti(this.productDto.Family));
      this.setInternetRole();


      let familyProductsRes = await this.productDownloadService.getProductReleases(this.productDto.Family,null,null,null,null,false,!this.isPlatinumPartner);
      if(!familyProductsRes.Result || !familyProductsRes.Content) throw new Error();
      this.familyProducts = familyProductsRes.Content;
      this.familyProductsOriginal = this.familyProducts;
      this.isLoading = false
    } catch (err){
      this.isLoading = false
    }

    this.search.controls['searchString'].valueChanges.debounceTime(100).subscribe(value => { this.searchProductRelease(value) })
  }

  getProductCodeZucchetti(pc: string) {
    switch (pc) {
        case "MAGOWEB":
            return ProductCode.MAGOWEB;
        case "MAGOCLD":
            return ProductCode.MAGOCLD;
        case "MAGO4":
        case "MAGO.NET":
          return ProductCode.MAGO4;
    }
  }
  
  setInternetRole(){
    this.internetRole = `${this.productDto.Family.toLowerCase()}Updates`;
    this.internetRole = this.internetRole.replace('.', '');
    this.internetRole = this.internetRole[0].toLocaleUpperCase() + this.internetRole.slice(1,4) + this.internetRole[4].toLocaleUpperCase() + this.internetRole.slice(5);
  }

  searchProductRelease(value: string){
    this.familyProducts = this.familyProductsOriginal.filter(p => {
      return ( p.Description.toLowerCase().trim().includes(value.toLowerCase().trim()) )
    })
  }
  AlphabeticSort() {
      this.familyProducts = this.familyProductsOriginal.sort((a, b) => {
      const titleA = a.Description.toUpperCase();
      const titleB = b.Description.toUpperCase();
      if (titleA < titleB) {
        return -1;
      }
      if (titleA > titleB) {
        return 1;
      }
      return 0;
    });
  }
  OriginalSort(){
    this.familyProducts = this.familyProductsOriginal.sort((a, b) =>
     a.DownloadPosition - b.DownloadPosition);
    }

    DateSort() {
        this.familyProducts = this.familyProductsOriginal.sort((a, b)  =>
          new Date(b.PublicationDate).getTime() - new Date(a.PublicationDate).getTime());
    }

  ActiveOrder(typeOrder: string)
  {
    this.activeOrder= typeOrder;
    switch (typeOrder){
      case 'weight': return this.OriginalSort();
      case 'alphabetic': return this.AlphabeticSort();
      case 'date': return this.DateSort();

    }
    this.AlphabeticSort()
  }
  getButtonFilterClasses(buttonString: string){
    return buttonString == this.activeFilter ? [`bg-selectedButton`] : [ 'bg-none']
  }

  getButtonOrderClasses(buttonString: string){
    return buttonString == this.activeOrder ? [`bg-selectedButton`] : [ 'bg-none']
  }

  getVisibleReleases() {
    let searchRole = this.convertFilterStringToInternetRole(this.activeFilter)
    if(searchRole == '') return this.familyProducts;
    return this.familyProducts.filter(r => {
      return (this.getInternetRole(r.InternetRole.replace(" ", "").split(';')) == searchRole )
    })
  }

  convertFilterStringToInternetRole(filterString: string): string{
    switch (filterString){
      case 'all': return ''
      case 'executable': return this.internetRole
      case 'development': return 'DevDownloads'
    }
  }

  clearSearch(){
    this.search.controls['searchString'].setValue('');
  }

  getInternetRole(internetRoles: string[]) : string{
    if(internetRoles.includes('DevDownloads')) return 'DevDownloads';
    if(internetRoles.includes('MobileToolsDownload')) return 'MobileToolsDownload';
    if(internetRoles.includes(this.internetRole)) return this.internetRole;
    return '';
  }

  public openRelease(){
    this.navigateService.setLocalStorageData('productDto', JSON.stringify(this.productDto))
    this.router.navigate(['/products-download/product-viewer']);
  }

  getButtonFilterText(filterString: string): string{
    switch (filterString){
      case 'all': return this.variable.all
      case 'development': return this.variable.development
      case 'executable': return this.variable.executables
      case 'mobile': return this.variable.executables
    }
  }

  getButtonOrderText(orderString: string): string{
    switch (orderString){
      case 'weight': return this.variable.weight
      case 'date': return this.variable.publicationDate
      case 'alphabetic': return this.variable.alphabetic

    }
  }
}
